export class CashRegisterControlTapeVendorHandleRequest {
    cashRegisterId?: number;
    requestData?: string;
    responseData?: string;
}  